<loading class="fullscreen"></loading>
<public-top-navigation></public-top-navigation>
<div class="smooth-wrapper">
  <div class="smooth-content">
    <router-outlet></router-outlet>
    <app-footer></app-footer>
  </div>
</div>
